<template>
    <div class="tw-w-106 tw-max-w-full tw-mx-2 xl:tw-w-130 xl:tw-mx-0">
        <div class="tw-p-8 tw-bg-white tw-rounded-xl">
            <h1
                class="tw-p-0 tw-m-0 tw-text-2xl tw-mb-4 tw-pb-4 tw-border-0 tw-border-b tw-border-solid tw-border-gray-200 tw-flex tw-items-center tw-font-bold"
            >
                <template v-if="isSuccess">
                    {{ $t("auth.passwordResetRequest.titleSuccess") }}
                </template>
                <template v-else>
                    {{ $t("auth.passwordResetRequest.title") }}
                </template>
            </h1>

            <div v-if="isSuccess">
                {{ $t("auth.passwordResetRequest.bodySuccess") }}
            </div>
            <form v-else class="tw-space-y-8" @submit.prevent="onSubmit">
                <div>
                    <l-input-text
                        :label="$t('auth.generic.labels.email')"
                        type="email"
                        :value.sync="form.email"
                        class="tw"
                        data-test-id="reset-password-request-email"
                    />
                </div>

                <l-text-alert
                    v-if="hasError"
                    type="danger"
                    data-test-id="error"
                    :text="errorMessage"
                />

                <l-base-button
                    :disabled="isSubmitButtonDisabled"
                    :button-types="['primary', 'raised']"
                    type="submit"
                >
                    {{ $t("auth.passwordResetRequest.formSubmitAction") }}
                </l-base-button>
            </form>
        </div>
    </div>
</template>

<script>
import LInputText from "@/components/LInputText";
import LTextAlert from "@/components/LTextAlert";
import LBaseButton from "@/components/LBaseButton";

export default {
    components: {
        LInputText,
        LTextAlert,
        LBaseButton,
    },
    data() {
        return {
            hasError: false,
            errorMessage: "",
            isLoading: false,
            isSuccess: false,
            form: {
                email: this.$route.query.email ?? "",
            },
        };
    },
    computed: {
        isSubmitButtonDisabled() {
            return this.isLoading;
        },
    },
    methods: {
        async onSubmit() {
            this.hasError = false;
            this.isLoading = true;

            try {
                await this.$store.dispatch("auth/passwordResetRequest", {
                    payload: { username: this.form.email },
                });

                this.isSuccess = true;
            } catch (err) {
                this.hasError = true;
                this.errorMessage = err.response?.data?.message ?? err.message;
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
